import React from 'react';

type Props = {
    id: string;
    name: string;
    label?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export default function Checkbox(props: Props) {
    const { checked, name, onChange, label, id } = props;

    return (
        <>
            <input id={id} type={"checkbox"} checked={checked} name={name} onChange={e => onChange(e.target.checked)}/>
            <label htmlFor={id}>{label}</label>
        </>
    );
}